import angularJsUtilitiesModule from "../angularJsUtilitiesModule";
import { CurrentUser, EnvironmentUrls } from "Roblox";

function abTestCheckService($q, abTestCheckConstant, httpService) {
    "ngInject";

    function checkAbTestEnrollnment(subjectType, targetId, experimentName, targetVariation) {
        var data = [{
            SubjectType: subjectType,
            SubjectTargetId: targetId,
            ExperimentName: experimentName
        }];

        var urlConfig = {
            url: EnvironmentUrls.abtestingApiSite + abTestCheckConstant.urls.checkEnrollment,
            retryable: false,
            withCredentials: true
        }

        var returnObject = {
            enrolled: false,
            success: false,
            variation: null
        };

        return $q(function (resolve, reject) {
            if (!EnvironmentUrls) {
                reject({
                    code: abTestCheckConstant.errorsCode.noRobloxEnvironmentUrls,
                    message: "No Roblox EnvironmentUrls."
                });
            }

            httpService.httpPost(urlConfig, data)
                .then(function (response) {
                    if (response.data && response.data.length > 0) {
                        var result = response.data[0];
                        returnObject.success = result? true:false;
                        returnObject.variation = result.Variation;
                        returnObject.enrolled = result.ExperimentName && result.Variation == targetVariation;
                        resolve(returnObject);
                    }
                }, function (error) {
                    reject(error);
                });
        });
    }

    function checkAbTestEnrollnmentByUserId(experimentName, targetVariation) {
        return checkAbTestEnrollnment(abTestCheckConstant.subjectType.user, CurrentUser.userId, experimentName, targetVariation);
    }

    return {
        checkAbTestEnrollnmentByUserId: checkAbTestEnrollnmentByUserId
    }
};

angularJsUtilitiesModule.factory("abTestCheckService", abTestCheckService);

export default abTestCheckService;